import { useAccountContext } from '@gonfalon/app-context/useAccountContext';
import {
  enableBillingPage,
  enableMarketplaceBilling,
  enableRelaxedBillingUIAccess,
  isPlanChangeEnabled,
} from '@gonfalon/dogfood-flags/dogfood-flags';
import { hasAdminRights } from '@gonfalon/members/hasAdminRights';
import { isAdmin } from '@gonfalon/members/isAdmin';
import { isOwner } from '@gonfalon/members/isOwner';

import { isMarketplace } from '../../subscriptions';

export function useBillingPermissions() {
  const { subscription, profile } = useAccountContext();
  // Marketplace subscriptions have their billing managed by a third party, they cannot change their plan within our app
  const isMarketplaceSubscription = isMarketplace(subscription);

  const shouldBlockPlanChangeForMarketplaceSubscriptions = enableMarketplaceBilling() && isMarketplaceSubscription;

  // Federal hides the billing UI to non-owners/admins by default
  // This could be replaced with custom billing and usage read permissions later on,
  // but billing & usage data is often required for feature management
  const isRelaxedBillingUIAccess = enableRelaxedBillingUIAccess();
  const isAdminOrCustomRole = hasAdminRights(profile);
  const isStrictOwnerOrAdmin = isOwner(profile) || isAdmin(profile);

  const isBillingAdmin = isRelaxedBillingUIAccess ? isAdminOrCustomRole : isStrictOwnerOrAdmin;

  return {
    canChangePlan: isBillingAdmin && isPlanChangeEnabled() && !shouldBlockPlanChangeForMarketplaceSubscriptions,
    // Marketplace subscriptions manage plan changes externally, but can still self-serve trial extensions.
    canExtendTrial: isBillingAdmin,
    canViewAccountUsage: isRelaxedBillingUIAccess || isStrictOwnerOrAdmin,
    canViewBilling: isBillingAdmin && enableBillingPage(),
  };
}
